import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedCubicMeterCalculator from "./SharedCubicMeterCalculator";
const TITLE = "Calculatrice de mètre cube électronique - Apprenez à calculer le mètre cube";
const DESCRIPTION =
  "Calculatrice de mètre cube électronique - Apprenez à calculer le mètre cube. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "cubic meter calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/cubicmeter";
function Calculator() {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Le mètre cube est une unité de mesure utilisée pour calculer la capacité ou le volume de différentes formes. Il existe de nombreuses formes géométriques qui nécessitent des lois spéciales pour calculer leur volume. Si nous considérons un cube de 2 mètres de long, 2 mètres de large et 2 mètres de haut, nous pouvons utiliser la formule de volume du cube représentée par la longueur multipliée par la largeur multipliée par la hauteur. Cela signifie que le volume du cube sera de 8 mètres cubes.
                <br />
                L'utilisation du mètre cube comme unité de mesure standard contribue à simplifier les calculs de volumes et de capacités pour diverses formes géométriques.
                <br />
                <b>
                  L'utilisation du mètre cube comme unité de mesure standard contribue à simplifier les calculs de volumes et de capacités pour diverses formes géométriques."
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <SharedCubicMeterCalculator />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
